import { render } from "./TheLogout.vue?vue&type=template&id=5f4ea388"
import script from "./TheLogout.vue?vue&type=script&lang=js"
export * from "./TheLogout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__